module.exports = __webpack_public_path__ + "static/media/tab_settings.68bba61b.svg";